import {Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable, Subject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {map} from 'rxjs/operators';

@Component({
    selector: 'app-generic-content',
    imports: [CommonModule],
    templateUrl: './generic-content.component.html',
    styleUrls: ['./generic-content.component.scss']
})
export class GenericContentComponent implements OnInit {
  http = inject(HttpClient);
  route = inject(ActivatedRoute);
  content: Subject<any> = new Subject<any>();

  constructor() {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.getContent(params)
    });
  }

  getContent(params: any) {
    this.http.get<any>(`${environment.baseUrl}/applications/help/`, {params})
      .pipe(
        map(r => r.results.length === 1 ? r.results[0] : {help_label: "404", help_text: "Sorry, no matching content found."})
      )
      .subscribe((response) => {
        this.content.next(response)
      })
  }
}
